import {
  InStudioNodeEditorPreview,
  InStudioNodeEditorPreviewProps,
  SetTemplateEditStateFn,
} from 'modules/templateEditor/integrations/InStudioTemplateEditing';
import { Dispatch, SetStateAction } from 'react';
import noop from 'utils/noop';

export interface TemplatePreviewAuroraProps
  extends Omit<InStudioNodeEditorPreviewProps, 'setTemplateEditState'> {
  /** The id of the template for which we want to display the preview */
  templateId: number;
  /** The id of the campaign */
  campaignId?: number;
  /** Callback for when the state changes */
  onStateUpdate?: SetTemplateEditStateFn;
  currentLocale?: string;
  setCurrentLocale: Dispatch<SetStateAction<string | undefined>>;
}

export const TemplatePreviewAurora = ({
  onStateUpdate = noop,
  ...props
}: TemplatePreviewAuroraProps) => {
  return <InStudioNodeEditorPreview setTemplateEditState={onStateUpdate} {...props} />;
};
